import { useState } from "react";

import { useLendingVaultAllocation } from "@bridgesplit/abf-react";
import { Divider } from "@mui/material";
import { Row, Text } from "@bridgesplit/ui";

import AllocationTable from "./AllocationTable";
import { useVaultContext } from "../../VaultContext";
import { useAllocationSummaries } from "./util";
import { VaultInfoSection } from "../common";
import AllocationStats from "./AllocationStats";
import { TableFilter } from "../params/common";
import { AllocationColumn } from "../params/type";

const DEFAULT_COLUMNS = [AllocationColumn.Source, AllocationColumn.Allocation, AllocationColumn.Apy];

const ALL_COLUMNS = [
    AllocationColumn.Source,
    AllocationColumn.Allocation,
    AllocationColumn.Apy,
    AllocationColumn.CollateralDeposits
];

const REQUIRED_COLUMNS = [AllocationColumn.Source];
const MAX_COLUMNS = 3;

export default function VaultLoanAllocation() {
    const { vaultAddress, vaultExpanded } = useVaultContext();
    const { data: allocations } = useLendingVaultAllocation(vaultAddress, vaultExpanded?.principalMetadata.mint);
    const allocationSummaries = useAllocationSummaries(allocations);
    const [visibleColumns, setVisibleColumns] = useState<AllocationColumn[]>(DEFAULT_COLUMNS);

    return (
        <VaultInfoSection header="Loans">
            <AllocationStats />
            <Divider />
            <Row spaceBetween>
                <Text variant="h4">Allocation</Text>
                <TableFilter
                    allColumns={ALL_COLUMNS}
                    visibleColumns={visibleColumns}
                    setVisibleColumns={setVisibleColumns}
                    resetColumns={DEFAULT_COLUMNS}
                    requiredColumns={REQUIRED_COLUMNS}
                    maxColumns={MAX_COLUMNS}
                />
            </Row>

            <AllocationTable
                allocations={allocationSummaries}
                vaultExpanded={vaultExpanded}
                visibleColumns={visibleColumns}
            />
        </VaultInfoSection>
    );
}
